import React from "react";
import { ReactComponent as HappyFace } from "assets/img/svg/happy-face-emoji.svg";
import { ReactComponent as SadEmoji } from "assets/img/svg/sad-emoji.svg";
const containerStyle = {
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '21px'
}

const NoRowFound = ({ status }) => {
  if (status === "PAID")
    return (
      <div style={containerStyle}>
        <SadEmoji />
        <div>No collection has been received for this application</div>
      </div>
    );

  if (status === "UNPAID")
    return (
      <div style={containerStyle}>
        <HappyFace />
        <div>Great work! All the payments has been collected. </div>
      </div>
    );
  return "";
};

export default NoRowFound;
